/** HTML5 drag-payload helpers for (multi-item) drags between components.
 *  Ids are URI-encoded so the comma-joined `text/plain` payload survives ids
 *  containing commas or pipes (e.g. work-code group keys). */
import type { DragEvent } from "react";

export function setDragIds(e: DragEvent, ids: string[]): void {
  e.dataTransfer.setData("text/plain", ids.map(encodeURIComponent).join(","));
  e.dataTransfer.effectAllowed = "move";
}

export function parseDragIds(raw: string): string[] {
  return raw.split(",").filter(Boolean).map(decodeURIComponent);
}

/** Replace the browser's default drag image with a compact count badge —
 *  used when dragging a multi-selection so the ghost reads "N codes" instead
 *  of one row's snapshot. */
export function setCountDragImage(e: DragEvent, label: string): void {
  const ghost = document.createElement("div");
  ghost.textContent = label;
  ghost.style.cssText =
    "position:fixed;left:-1000px;top:-1000px;" +
    "background:#5EA348;color:#fff;font-size:12px;font-weight:700;" +
    "padding:6px 14px;border-radius:12px;white-space:nowrap;" +
    "box-shadow:0 2px 8px rgba(0,0,0,0.3);";
  document.body.appendChild(ghost);
  e.dataTransfer.setDragImage(ghost, ghost.offsetWidth / 2, ghost.offsetHeight / 2);
  requestAnimationFrame(() => ghost.parentNode?.removeChild(ghost));
}
